export class ClientPage {
    public page = ''
    public size = ''
    public entity = {}
}